import { useEffect, useState } from "react";

/**
 * Returns a debounced copy of `value` that only updates after `delay`ms of stability.
 * Used to prevent firing expensive backend requests on every keystroke.
 */
export default function useDebouncedValue(value, delay = 500) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}

/**
 * Validates that age-related inputs are sane enough to send to the backend.
 * Returns true only when current_age < retirement_age < life_expectancy and
 * all three are positive finite numbers in plausible ranges.
 */
export function arePlanAgesValid(inputs) {
  const c = Number(inputs?.current_age);
  const r = Number(inputs?.retirement_age);
  const l = Number(inputs?.life_expectancy);
  if (!Number.isFinite(c) || !Number.isFinite(r) || !Number.isFinite(l)) return false;
  // Mirror backend Pydantic bounds so we don't fire a guaranteed-422 request.
  if (c < 18 || c > 99) return false;
  if (r < 30 || r > 99) return false;
  if (l < 60 || l > 120) return false;
  if (c >= r) return false;
  if (r >= l) return false;
  return true;
}
